// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__i6eZn","label":"Radio_label__3Ikay","checkMark":"Radio_checkMark__1L2fu","disabled":"Radio_disabled__2tIcE"};